export const dataCell = (
  content: string | number | boolean | JSX.Element,
  options: {
    variant?: 'numeric' | 'grandTotal';
    dataTestId?: string;
  } = {},
) => ({
  content,
  variant: options.variant ?? 'numeric',
  ...(options.dataTestId ? { dataTestId: options.dataTestId } : {}),
});

export const rightAlignedHeader = (content: string) => ({
  content,
  align: 'right' as const,
  width: 'narrow' as const,
});

export const stackedGroupHeader = (content: string) => ({
  content,
  colSpan: 2,
  align: 'center' as const,
  height: 'stacked' as const,
});
